import { useLang } from '@/hooks/useLang';

const BASE = 'https://www.yamamoto-ss.co.jp/sp_recycle';

export default function ContactBanner() {
  const { t } = useLang();
  return (
    <div className="bg-[#0a0a0a] py-6 px-8">
      <div className="max-w-screen-xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-white/70 text-sm font-medium">
          {t(
            'Questions about EPS recycling equipment for North America?',
            '北米向けEPSリサイクル機器についてのご質問は'
          )}
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <a
            href={`${BASE}/products/catalog.html`}
            className="flex items-center gap-2 border border-white/20 text-white text-xs font-bold px-5 py-2.5 hover:border-white/60 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-download-line"></i>
            {t('Download Catalog', 'カタログダウンロード')}
          </a>
          <a
            href={`${BASE}/contact/`}
            className="flex items-center gap-2 bg-[#c0392b] text-white text-xs font-bold px-5 py-2.5 hover:bg-[#a93226] transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line"></i>
            {t('Contact Us', 'お問い合わせ')}
          </a>
        </div>
      </div>
    </div>
  );
}
